/*
 * Copyright (c) Worldline 2023.
 */

import {Component, Input, OnInit} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {PopoverMode} from "../../constant/popover-mode";
import {EvidenceUserHelperService} from "../../services/evidence-user-helper.service";

@Component({
    selector: 'app-wl-popover',
    templateUrl: './wl-popover.component.html'
})
export class WlPopoverComponent implements OnInit {

    constructor(private translateService: TranslateService, private evidenceUserHelperService: EvidenceUserHelperService) {
    }

    /**
     * The evidence content type
     */
    @Input()
    contenttype: any;

    /**
     * The evidence type
     */
    @Input()
    evidencetype: any;

    /**
     * The evidence part name
     */
    @Input()
    partname: any;

    /**
     * The evidence button id
     */
    @Input()
    buttonid: any;

    /**
     * The evidence state
     */
    @Input()
    evidencestate: any;

    @Input()
    popoverId: any


    evidenceUserHelperAvailable: any
    evidenceUserHelperImage: any
    evidenceUserHelperText: any

    ngOnInit(): void {
        //Put results of evidenceUserHelper object into the scope
        var result = this.evidenceUserHelperService.evidenceUserHelperState(this.evidencetype.type, this.partname, this.contenttype);

        this.evidenceUserHelperAvailable = result.evidenceUserHelperAvailable;
        this.evidenceUserHelperImage = result.image;
        var textKey = result.text;

        //Test if the key exists in platform catalog
        this.translateService.get(textKey).subscribe({
            next: () => {
                this.evidenceUserHelperText = textKey;
            },
            error: () => {
                this.evidenceUserHelperText = false
                if (this.evidenceUserHelperImage === null) {
                    this.evidenceUserHelperAvailable = false;
                }
            }
        })

        const popoverElement = document.getElementById(this.popoverId)!;

        //If evidence type choice
        if (this.evidencestate === PopoverMode.selectEvidencePart || this.evidencestate === PopoverMode.dispatchEvidencePart) {
            let buttonTypeChoiceElement = document.getElementById(this.buttonid)

            if (buttonTypeChoiceElement) {
                //Get button position + dimensions
                var buttonLeft = buttonTypeChoiceElement.offsetLeft;
                var buttonTop = buttonTypeChoiceElement.offsetTop;
                var buttonWidth = buttonTypeChoiceElement.offsetWidth;
                //var buttonHeight = buttonTypeChoiceElement.prop('offsetHeight');

                //Parent position
                //var parentTop = $element.parent().prop('offsetTop');

                //Define necessary positions
                let parentWidth;
                let parentMiddleHorizontal;
                let buttonRight;
                let popoverBottom;

                if (this.evidencestate === PopoverMode.selectEvidencePart) {
                    //Parent position
                    parentWidth = document.getElementById('popover')!.parentElement!.parentElement!.parentElement!.offsetWidth;
                    parentMiddleHorizontal = parentWidth / 2;

                    //Evidence section
                    let evidenceSection = document.getElementById('evidenceForm')!;
                    let evidenceSectionHeight = evidenceSection.offsetHeight;

                    buttonRight = parentWidth - (buttonLeft + buttonWidth);
                    popoverBottom = evidenceSectionHeight - buttonTop + 10;
                } else if (this.evidencestate === PopoverMode.dispatchEvidencePart) {
                    //Parent position
                    parentWidth = document.getElementById('affectPartChoiceSection')!.offsetWidth;
                    parentMiddleHorizontal = parentWidth / 2;

                    buttonRight = parentWidth - (buttonLeft + buttonWidth);
                    popoverBottom = -buttonTop + 10;
                }

                //Define new positions in css
                if (buttonLeft > parentMiddleHorizontal) {
                    popoverElement.classList.add('popover-right');
                    popoverElement.style.right = buttonRight + 'px';
                    popoverElement.style.bottom = popoverBottom + 'px';
                } else {
                    popoverElement.classList.add('popover-left');
                    popoverElement.style.left = buttonLeft + 'px';
                    popoverElement.style.bottom = popoverBottom + 'px';
                }
            }
        } else if (this.evidencestate === PopoverMode.uploadEvidencePart) {
            popoverElement.classList.add('popover-right')
            popoverElement.style.right = '1.3em'
            popoverElement.style.bottom = '3.3em'
        }
    }

    //Click on cross to close popover
    closePopover() {
        this.evidenceUserHelperService.closeAll();
    };

}